import { Action, createReducer, on } from '@ngrx/store';
import * as CurrentFarmActions from '../_actions/currentFarm';
import { Farm } from '../_models';

export interface CurrentFarmState {
  farm: Farm | null;
  loading: boolean;
  error: any;
}

export const initialCurrentFarmState: CurrentFarmState = {
  farm: null,
  loading: false,
  error: null,
};

export const currentFarmReducer = createReducer(
  initialCurrentFarmState,
  on(CurrentFarmActions.loadCurrentFarm, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CurrentFarmActions.loadCurrentFarmSuccess, (state, { farm }) => ({
    ...state,
    farm,
    loading: false,
  })),
  on(CurrentFarmActions.loadCurrentFarmFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(CurrentFarmActions.updateCurrentFarmSuccess, (state, { farm }) => ({
    ...state,
    farm, // Aggiorna il currentFarm con la farm aggiornata
    loading: false,
  }))
);

export function reducer(state: CurrentFarmState | undefined, action: Action) {
  return currentFarmReducer(state, action);
}
